import { render, staticRenderFns } from "./NoMenus.vue?vue&type=template&id=b2495214&"
import script from "./NoMenus.vue?vue&type=script&lang=js&"
export * from "./NoMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports